// @flow
import React from "react";
import styled from "styled-components";
import Button from "../Button";

import "./ServiceLoginIntro.scss";

type Props = {
    title: string,
    actionTitle: string,
    statement?: string,
    actionHandler: Function,
    btnClass: string,
    btnIcon?: string,
    dataTest?: string,
	footer?: string | React$Element<any>
};

const Footer = styled.div`
	position: absolute;
	bottom: 20px;
    left: 50%;
	transform: translate(-50%);
`;

const renderStatement = (statement) => (statement
	? <div className="statement">
		{statement}
	</div> : null);

const renderFooter = (footer) => footer ? <Footer data-test="service-intro-footer">
	{footer}
</Footer> : null;

const ServiceLoginIntro = (props: Props) => {
	return <div className="box login-intro relative">
		<h2 className="title bg-source-bg-c">{props.title}</h2>
		<Button dataTest={props.dataTest} text={props.actionTitle} icon={props.btnIcon}
		        colorName="link" className={`login ${props.btnClass}`}
		        onClick={props.actionHandler}/>
		{renderStatement(props.statement)}
		{renderFooter(props.footer)}
	</div>;
};

export default ServiceLoginIntro;
